import React  from "react";
import classes from "./FlexContainerNoWrap.module.css"
const FlexContainerNoWrap = (props)=>{
    
    return (
        <div className={classes.FlexContainer}> 
            {props.children}

        </div>
    )
}

export default FlexContainerNoWrap; 